import { Navigate } from "react-router-dom"
import Dashboard from "./pages/dashboard/Dashboard"
import Customers from "./pages/customers/Customers"
import CustomerDetail from "./pages/customers/CustomerDetails"
import Plans from "./pages/subscriptions/Plans"
import Subscriptions from "./pages/subscriptions/Subscriptions"
import SubscriptionDetail from "./pages/subscriptions/SubscriptionDetails"
import Settings from "./pages/settings/Settings"
import Profile from "./pages/settings/Profile"
import Organization from "./pages/settings/Organization"
import Login from "./pages/auth/Login"
import ForgotPassword from "./pages/auth/ForgotPassword"
import ResetPassword from "./pages/auth/ResetPassword"
import NotFound from "./pages/errors/NotFound"
import AnalyticsDashboard from "./pages/analytics/AnalyticsDashboard"
import WebhookManager from "./pages/webhooks/WebhookManager"
import PaymentRecoverySettings from "./pages/settings/PaymentRecoverySettings"
import EmailTemplatePreview from "./pages/settings/EmailTemplatePreview"

// Import the new payment recovery pages
import PaymentRecoveryEmailTemplates from "./pages/payment-recovery/PaymentRecoveryEmailTemplates"
import PaymentRecoveryAnalytics from "./pages/payment-recovery/PaymentRecoveryAnalytics"
import FailedPayments from "./pages/payment-recovery/FailedPayments"

// Import CreatePlan component
import CreatePlan from "./pages/subscriptions/CreatePlan"
// Import PlanDetails component
import PlanDetails from "./pages/subscriptions/PlanDetails"
// Import CustomerSubscription component
import CustomerSubscription from "./pages/subscriptions/CustomerSubscription"

// Import Credits pages
import Credits from "./pages/credits/Credits"
import CreditUsage from "./pages/credits/CreditUsage"
import CustomerCredits from "./pages/credits/CustomerCredits"
import CustomerCreditsList from "./pages/credits/CustomerCreditsList"

// Import Users pages
import Users from "./pages/users/Users"
import CreateUser from "./pages/users/CreateUser"
import UserDetails from "./pages/users/UserDetails"

// Import CreateCustomer component
import CreateCustomer from "./pages/customers/CreateCustomer"

// Import the CreateWebhook component
import CreateWebhook from "./pages/webhooks/CreateWebhook"

// Import Invoice pages
import Invoices from "./pages/billing/Invoices"
import InvoiceDetails from "./pages/billing/InvoiceDetails"
import CreateInvoice from "./pages/billing/CreateInvoice"

// Import Payment pages
import StripeCheckout from "./pages/payment/StripeCheckout"
import PaymentSuccess from "./pages/payment/PaymentSuccess"

const routes = [
  {
    path: "/",
    element: <Navigate to="/dashboard" replace />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/customers",
    element: <Customers />,
  },
  {
    path: "/customers/create",
    element: <CreateCustomer />,
  },
  {
    path: "/customers/:id",
    element: <CustomerDetail />,
  },
  {
    path: "/plans",
    element: <Plans />,
  },
  {
    path: "/plans/create",
    element: <CreatePlan />,
  },
  {
    path: "/plans/:id",
    element: <PlanDetails />,
  },
  {
    path: "/subscriptions",
    element: <Subscriptions />,
  },
  // More specific route comes first
  {
    path: "/subscriptions/customer/:id",
    element: <CustomerSubscription />,
  },
  // Less specific route comes after
  {
    path: "/subscriptions/:id",
    element: <SubscriptionDetail />,
  },
  // Payment routes
  {
    path: "/payment/checkout",
    element: <StripeCheckout />,
  },
  {
    path: "/payment/success",
    element: <PaymentSuccess />,
  },
  {
    path: "/settings",
    element: <Settings />,
    children: [
      {
        path: "",
        element: <Navigate to="/settings/profile" replace />,
      },
      {
        path: "profile",
        element: <Profile />,
      },
      {
        path: "organization",
        element: <Organization />,
      },
      {
        path: "payment-recovery",
        element: <PaymentRecoverySettings />,
      },
      {
        path: "email-templates",
        element: <EmailTemplatePreview />,
      },
    ],
  },
  {
    path: "/analytics",
    element: <AnalyticsDashboard />,
  },
  {
    path: "/webhooks",
    element: <WebhookManager />,
    requiresAuth: true,
  },
  // Add the route for creating webhooks
  {
    path: "/webhooks/create",
    element: <CreateWebhook />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/reset-password/:token",
    element: <ResetPassword />,
  },
  // Add Users routes
  {
    path: "/users",
    element: <Users />,
  },
  {
    path: "/users/create",
    element: <CreateUser />,
  },
  {
    path: "/users/:id",
    element: <UserDetails />,
  },
  {
    path: "/payment-recovery/settings",
    element: <PaymentRecoverySettings />,
  },
  {
    path: "/payment-recovery/email-templates",
    element: <PaymentRecoveryEmailTemplates />,
  },
  {
    path: "/payment-recovery/analytics",
    element: <PaymentRecoveryAnalytics />,
  },
  {
    path: "/payment-recovery/failed-payments",
    element: <FailedPayments />,
  },
  // Credits routes
  {
    path: "/credits",
    element: <Credits />,
  },
  {
    path: "/credits/usage",
    element: <CreditUsage />,
  },
  {
    path: "/credits/customer",
    element: <CustomerCreditsList />,
  },
  {
    path: "/credits/customer/:id",
    element: <CustomerCredits />,
  },
  // Invoice routes
  {
    path: "/billing/invoices",
    element: <Invoices />,
  },
  {
    path: "/billing/invoices/create",
    element: <CreateInvoice />,
  },
  {
    path: "/billing/invoices/:id",
    element: <InvoiceDetails />,
  },
  // This must be the last route
  {
    path: "*",
    element: <NotFound />,
  },
]

export default routes

